import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '@services/app.service';
import { User } from 'firebase/auth';
import { Observable } from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-5 bg-white overflow-hidden position-fixed';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user?: User;
    public menuItems : any [] = [];
    userType: string = "";

    constructor(
        public appService: AppService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.userType = localStorage.getItem('userType')
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
        });
        this.user = this.appService.user;
        switch (this.userType) {
            case 'ADMIN':
                this.menuItems = MENU;
                break;
            default:
                this.menuItems = []; // or show limited menu
                break;
        }
    }
}

export const MENU = [
    {
        name: 'Add-New-Certificate',
        iconClasses: 'fas fa-clipboard-list',
        path: ['/main/add-certificate']
    },
    {
        name: 'View-Certificate',
        iconClasses: 'fas fa-table',
        path: ['/main/admin-certificate-list-table']
    }
];
